<template>
    <div class="english-container">
  
      <h1>Quick Start</h1>
  
      <h2>Android:</h2>
  
      <ol>
        <li>
          Power on the smart card.
          Wait for the pop-up to show smart card.
          If the pop-up does not appear, continue with the following steps.
        </li>
  
        <li>
          Open Settings, go to “Google”, then tap “All services”.
        </li>
  
        <li>
          In the “Connected Devices & Sharing” menu,
          select “Devices”.
        </li>
  
        <li>
          Enable “Scan for Nearby Devices”.
        </li>
  
        <li>
          The smart card will appear in the list of nearby available devices.
        </li>
  
        <li>
          Tap the device and follow the on-screen instructions
          to complete the connection.
        </li>
      </ol>
  
      <div class="divider"></div>
  
      <h2>Find Nearby</h2>
  
      <p>
        In the “Google Find Hub” app,
        select your smart card and tap “Play Sound”
        to locate your device.
        Once found, tap “Stop Sound” to silence the device.
      </p>
  
      <h2>Find Far Away</h2>
  
      <p>
        In the “Google Find Hub” app,
        select your smart card and tap the device
        to view its location.
      </p>
  
      <p>
        To navigate to the location,
        tap “Get Directions” to open map navigation.
      </p>
  
      <div class="divider"></div>
  
      <h1>Reset</h1>
  
      <ol>
        <li>
          Open the “Google Find Hub” app,
          select your smart card,
          tap the Settings button,
          then tap “Remove from Find Hub”
          and confirm.
        </li>
  
        <li>
          When the device is turned on,
          press the button five times continuously.
          On the fifth press, keep holding the button
          until you hear the prompt tone.
        </li>
      </ol>
  
      <p class="remark">
        Note:
        Please power on the smart card
        and remove the device from the
        “Google Find Hub” app before resetting.
      </p>
  
      <div class="divider"></div>
  
      <h1>Fast Pair Instruction</h1>
  
      <h2>Add Smart Card</h2>
  
      <ol>
        <li>
          Make sure your phone’s Bluetooth
          and network connection are turned on.
        </li>
  
        <li>
          Press the button once to turn on the smart card
          (a beep sound will be heard).
        </li>
  
        <li>
          Bring the smart card close to your Android device
          and wait for the pop-up to appear.
          <br />
          <strong>Remark:</strong>
          If no pop-up appears,
          please restart your phone and try again.
        </li>
  
        <li>
          Tap “Connect”, then read and accept the prompts
          to complete pairing.
        </li>
  
        <li>
          In the “Google Find Hub” app,
          select “Smart Card”
          to customize the device name and category.
        </li>
      </ol>
  
      <div class="divider"></div>
  
      <h1>Enable Lost Mode</h1>
  
      <p>
        In the “Google Find Hub” app,
        select your smart card
        and tap “Mark as Lost”.
      </p>
  
      <p>
        Add your contact information
        and you will receive a notification
        if the Find Hub network locates your device.
      </p>
  
      <h2>Smart Card Location Sharing</h2>
  
      <p>
        In the “Google Find Hub” app,
        select your smart card,
        then tap “Share Device”.
      </p>
  
      <h2>Connect to Another Phone</h2>
  
      <p>
        After completing the reset process,
        connect the smart card to another Android phone.
      </p>
  
      <div class="divider"></div>
  
      <h1>Charge</h1>
  
      <p>
        Use regular wireless charging equipment
        to charge the product wirelessly.
      </p>
  
      <p>
        The red light stays on while charging
        and turns off once fully charged.
      </p>
  
    </div>
  </template>
  
  <script>
  export default {
    name: 'AndroidEnglishGuide',
  };
  </script>
  
  <style scoped>
  
  .english-container{
    background-color:#ffffff;
    border-radius:8px;
    padding:30px;
    margin:10px auto;
    max-width:1000px;
    box-shadow:0 2px 8px rgba(0,0,0,0.08);
  }
  
  h1{
    font-size:40px;
    margin-top:10px;
    margin-bottom:20px;
    color:#222;
    text-align:left;
  }
  
  h2{
    font-size:24px;
    margin-top:28px;
    margin-bottom:12px;
    color:#333;
    text-align:left;
  }
  
  p{
    font-size:15px;
    line-height:1.8;
    color:#333;
    margin-bottom:14px;
    text-align:left;
  }
  
  ol{
    padding-left:24px;
    margin-bottom:20px;
  }
  
  li{
    font-size:15px;
    line-height:1.8;
    color:#333;
    margin-bottom:10px;
    text-align:left;
  }
  
  strong{
    color:#222;
  }
  
  .remark{
    font-size:14px;
    color:#666;
    background:#f8f8f8;
    padding:12px 14px;
    border-left:4px solid #ff4fa0;
    border-radius:4px;
  }
  
  .divider{
    width:100%;
    height:1px;
    background:#e5e5e5;
    margin:40px 0;
  }
  
  @media (max-width:768px){
  
    .english-container{
      padding:20px;
    }
  
    h1{
      font-size:30px;
    }
  
    h2{
      font-size:20px;
    }
  
    p, li{
      font-size:14px;
    }
  }
  
  </style>